export class DiaryZoomLevels {
  public static ZOOM_LEVELS: any[] = [
    // {
    //   width: 200,
    //   increment: 4,
    //   resolution: 60,
    //   preset: 'hourAndDay',
    //   resolutionUnit: 'minute'
    // },
    // {
    //   width: 300,
    //   increment: 3,
    //   resolution: 60,
    //   preset: 'hourAndDay',
    //   resolutionUnit: 'minute'
    // },
    // {
    //   width: 400,
    //   increment: 2,
    //   resolution: 30,
    //   preset: 'hourAndDay',
    //   resolutionUnit: 'minute'
    // },
    {
      //   width: 500,
      //   increment: 1,
      // resolution: 15,
      preset: "dayAndWeek"
      //   resolutionUnit: 'day'
    }
  ];
}
